"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const SchemaLayout_1 = tslib_1.__importDefault(require("./SchemaLayout"));
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const AbstractGrid_1 = tslib_1.__importDefault(require("../AbstractGrid"));
class WCAGSchema extends AbstractGrid_1.default {
    static extractWCAGSchemaArgs(args) {
        if (!args[0].schemaConfig) {
            const [gridConfig] = args;
            return {
                schemaConfig: gridConfig,
                schemaCssClass: "custom-schema",
                successMessage: "Data indlæst",
                loadingMessage: "Indlæser data",
                failedMessage: "Det mislykkedes at indlæse data",
                emptyMessage: "Der er ikke registreret noget data"
            };
        }
        return args[0];
    }
    constructor(...args) {
        super({
            ...WCAGSchema.extractWCAGSchemaArgs(args),
            gridConfig: WCAGSchema.extractWCAGSchemaArgs(args).schemaConfig,
            gridCssClass: WCAGSchema.extractWCAGSchemaArgs(args).schemaCssClass
        });
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        this.numberOfRowsChangedHandlerManager = new fmko_ts_common_1.HandlerManager();
        this.addRowButtonVisible = true;
        this.addRowButtonEnabled = true;
        this.removeCssClass("grid");
        this.removeTableCssClass("grid-table");
        this.addCssClass("schema");
        this.addTableClasses("schema-table");
        this.loadingWidget.removeCssClass("grid-loading");
        this.loadingWidget.addCssClass("schema-loading");
    }
    render() {
        super.render();
        this.getTableElement().setAttribute("role", fmko_ts_common_1.ARIARole.GRID);
        if (!this.addRowButton) {
            this.addRowButton = new fmko_ts_widgets_1.StyledButton({
                buttonImage: fmko_ts_widgets_1.ButtonImage.PLUS,
                clickHandler: () => this.onRowAddButtonClicked(),
                text: "Tilføj række"
            });
            this.addRowButton.setVisible(this.addRowButtonVisible);
            this.addRowButton.setEnabled(this.addRowButtonEnabled);
            this.addRowButton.addCssClass("empty-schema");
            this.element.appendChild(this.addRowButton.element);
            this.addRowButton.addCssClass("add-row-button");
        }
        else {
            this.addRowButton.setVisible(this.addRowButtonVisible);
            this.addRowButton.setEnabled(this.addRowButtonEnabled);
        }
    }
    getValue() {
        return this.getData();
    }
    setValue(value, fireEvents) {
        this.oldValue = this.getValue();
        if (!fmko_ts_common_1.CompareUtil.deepEquals(this.oldValue, value)) {
            this.setData(value);
            if (fireEvents) {
                this.numberOfRowsChanged();
            }
        }
        if (fireEvents) {
            this.valueChanged();
        }
    }
    setAddRowButtonVisible(visible) {
        this.addRowButton.setVisible(visible);
        this.addRowButtonVisible = visible;
    }
    setAddRowButtonLabel(label) {
        this.addRowButton.setText(label);
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    addNumberOfRowsChangedHandler(handler) {
        return this.numberOfRowsChangedHandlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    setEnabled(enabled) {
        this.addRowButton.setEnabled(enabled);
        this.addRowButtonEnabled = enabled;
        for (const columnConfig of this.gridConfig.columnConfigs) {
            columnConfig.setEnabled(enabled);
        }
    }
    addRow(rowToAdd, fireEvents = false) {
        const oldData = [...this.getValue()];
        oldData.push(rowToAdd ?? {});
        this.setValue(oldData, fireEvents);
        this.addRowButton.element.focus();
    }
    getCellWidget(td) {
        return super.getCellWidget(td);
    }
    setLastFocusedCell(lastFocusedCell) {
        this.gridLayout.setLastFocusedCell(lastFocusedCell);
    }
    resetLayout() {
        this.setGridLayout(new SchemaLayout_1.default(this));
    }
    onRowAddButtonClicked() {
        this.addRow(undefined, true);
    }
    valueChanged(forceEvent = false) {
        const value = this.getValue();
        if (forceEvent) {
            fmko_ts_common_1.ValueChangeEvent.fire(this, value);
        }
        else {
            fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, this.oldValue, value);
        }
    }
    numberOfRowsChanged(forceEvent = false) {
        const value = this.getValue();
        this.addRowButton.toggleCssClass("empty-schema", value.length === 0);
        if (forceEvent) {
            fmko_ts_common_1.ValueChangeEvent.fire(this, value);
        }
        else {
            const difference = this.oldValue.length - value.length;
            if (difference !== 0) {
                this.numberOfRowsChangedHandlerManager.fireEvent(new fmko_ts_common_1.ValueChangeEvent(value.length));
            }
        }
    }
}
exports.default = WCAGSchema;
//# sourceMappingURL=WCAGSchema.js.map